import React, { useState, useEffect } from 'react';
import {
  Facebook,
  Instagram,
  Youtube,
  MessageCircle
} from 'lucide-react';
import ContactPopup from '../../components/ContactPopup';

const FloatingIcons = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isContactOpen, setIsContactOpen] = useState(false);

  const socialLinks = [
    {
      icon: Youtube,
      href: "https://www.youtube.com/@SYMMachinery",
      label: "YouTube",
      bg: "bg-red-600",
      shadow: "shadow-red-600/50"
    },
    {
      icon: Facebook,
      href: "/facebook-updates",
      label: "Facebook",
      bg: "bg-blue-600",
      shadow: "shadow-blue-600/50"
    },
    {
      icon: Instagram,
      href: "/instagram-updates",
      label: "Instagram",
      bg: "bg-pink-600",
      shadow: "shadow-pink-600/50"
    },
  ];

  // Scroll handler
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  // Resize handler
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {/* ===== SOCIAL ICONS - LEFT SIDE ===== */}
      {/* Desktop */}
      {!isMobile && (
        <div
          className={`fixed left-3 top-1/2 -translate-y-1/2 z-[9998] flex flex-col gap-3 transition-all duration-500 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-16 pointer-events-none'
          }`}
        >
          {socialLinks.map(({ icon: Icon, href, label, bg, shadow }, index) => (
            <a
              key={index}
              href={href}
              target={href.startsWith("/") ? "_self" : "_blank"}
              rel={href.startsWith("/") ? undefined : "noopener noreferrer"}
              className="block transition-all duration-300 hover:scale-110 hover:shadow-2xl"
              aria-label={label}
            >
              <div
                className={`
                  w-12 h-12 rounded-full flex items-center justify-center
                  ${bg} shadow-lg ${shadow}
                  border-2 border-white/20
                  transition-all duration-300
                  hover:scale-110
                  animate-float
                `}
                style={{ animationDelay: `${index * 0.3}s` }}
              >
                <Icon className="w-5 h-5 text-white drop-shadow-md" />
              </div>
            </a>
          ))}
        </div>
      )}

      {/* Mobile */}
      {isMobile && (
        <div
        className={`fixed left-2 bottom-32 z-[9998] flex flex-col gap-4 transition-all duration-500 ${
  isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-16 pointer-events-none'
}`}
        >
          {socialLinks.map(({ icon: Icon, href, label, bg, shadow }, index) => (
            <a
              key={index}
              href={href}
              target={href.startsWith("/") ? "_self" : "_blank"}
              rel={href.startsWith("/") ? undefined : "noopener noreferrer"}
              className="block transition-all duration-300 active:scale-90"
              aria-label={label}
            >
              <div
                className={`
                  w-12 h-12 rounded-full flex items-center justify-center
                  ${bg} shadow-md ${shadow}
                  border-2 border-white/20
                  transition-all duration-300
                  animate-float
                `}
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <Icon className="w-7 h-7 text-white drop-shadow-sm" />
              </div>
            </a>
          ))}
        </div>
      )}

      {/* ===== FLOATING CONTACT BUTTON - RIGHT SIDE ===== */}
     <div
  className={`fixed left-6 bottom-6 z-[9999] transition-all duration-500 ${
    isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-20 pointer-events-none'
  }`}
>
        <button
          onClick={() => setIsContactOpen(true)}
          className="group relative flex items-center gap-4 px-7 py-4 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-black font-bold rounded-full shadow-2xl hover:shadow-yellow-500/40 transition-all duration-300 hover:scale-105 active:scale-95"
        >
          <span className="absolute inset-0 rounded-full border-2 border-yellow-400/60 animate-ping opacity-40"></span>
          <MessageCircle className="w-5 h-5 relative z-10" />
          <span className="relative z-10 font-semibold">Contact Us</span>
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse border-2 border-white"></span>
        </button>
      </div>

      {/* ===== YOUR EXISTING CONTACT POPUP ===== */}
      <ContactPopup isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />

      {/* Animation Styles */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </>
  );
};

export default FloatingIcons;